module.exports = __webpack_public_path__ + "img/giropos.118885ca.png";